/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Version_LabelInputs */



/**
* | output |
* | --- |
* | "Version {version}" |
*
* @param {Version_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const version_label = /** @type {((inputs: Version_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Version_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Version ${i?.version}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Version ${i?.version}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Versione ${i?.version}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Версия ${i?.version}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Versión ${i?.version}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`版本 ${i?.version}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`バージョン ${i?.version}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संस्करण ${i?.version}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Versão ${i?.version}`)
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
});